const common = {
  siteName: 'CSSBuy Spreadsheet',
  siteTagline: 'Planilhas Atualizadas 2026',
  heroTitle: 'Melhor CSSBuy Spreadsheet 2026',
  heroSubtitle: 'Descubra os melhores produtos, vendedores confiáveis e links atualizados do CSSBuy Spreadsheet.',
  ctaSpreadsheet: 'Ver Spreadsheet Agora',
  ctaExplore: 'Explorar Produtos',
  ctaBuyNow: 'Buy It Now',
  ctaCssbuySheet: 'CSSBuy Sheet',
  trustTitle: 'Por que confiar no nosso CSSBuy Spreadsheet?',
  trust1: 'Links atualizados diariamente',
  trust2: 'Verificação de qualidade (QC)',
  trust3: 'Guias completos de envio',
  trust4: 'Produtos populares da comunidade',
  trust5: 'Economia em frete internacional',
  whatIsTitle: 'O que é o CSSBuy Spreadsheet?',
  whatIsDesc1: 'O CSSBuy Spreadsheet é uma coleção organizada de produtos, vendedores e recomendações que ajudam compradores a encontrar os melhores itens da China com segurança.',
  whatIsDesc2: 'A plataforma permite comparar preços, verificar fotos QC e encontrar produtos populares entre a comunidade de compradores internacionais.',
  whyUseTitle: 'Por que usar o CSSBuy Spreadsheet?',
  whyUse1: 'Economize dinheiro com preços comparados',
  whyUse2: 'Compare vendedores confiáveis',
  whyUse3: 'Veja avaliações reais da comunidade',
  whyUse4: 'Reduza riscos em compras internacionais',
  whyUse5: 'Descubra produtos populares e tendências',
  comparisonTitle: 'CSSBuy Spreadsheet vs Pesquisa Manual',
  comparisonCol1: 'Recurso',
  comparisonCol2: 'CSSBuy Spreadsheet',
  comparisonCol3: 'Pesquisa Manual',
  comparisonEconomy: 'Economia',
  comparisonQC: 'Verificação QC',
  comparisonLinks: 'Links Rápidos',
  comparisonCommunity: 'Comunidade',
  comparisonSafety: 'Segurança',
  comparisonYes: '✓',
  comparisonNo: '✗',
  faqTitle: 'Perguntas Frequentes sobre CSSBuy Spreadsheet',
  faqQ1: 'O CSSBuy Spreadsheet é gratuito?',
  faqA1: 'Sim, disponibilizamos o CSSBuy Spreadsheet com links atualizados gratuitamente para toda a comunidade. Nosso objetivo é ajudar compradores a encontrar os melhores produtos com segurança e economia.',
  faqQ2: 'Com que frequência o CSSBuy Spreadsheet é atualizado?',
  faqA2: 'Atualizamos nosso CSSBuy Spreadsheet diariamente com novos produtos, vendedores verificados e links confirmados. A comunidade também contribui com recomendações e avaliações.',
  faqQ3: 'O CSSBuy Spreadsheet funciona para o Brasil?',
  faqA3: 'Sim! O CSSBuy Spreadsheet é totalmente compatível com compradores do Brasil e Portugal. Incluímos informações específicas sobre envio internacional, taxas e melhores práticas para a comunidade lusófona.',
  faqQ4: 'Como verificar a qualidade dos produtos no CSSBuy Spreadsheet?',
  faqA4: 'Cada produto no CSSBuy Spreadsheet inclui fotos QC verificadas e avaliações da comunidade. Recomendamos sempre solicitar fotos QC adicionais antes do envio internacional.',
  faqQ5: 'O CSSBuy Spreadsheet inclui marcas como Nike e Jordan?',
  faqA5: 'Sim! O CSSBuy Spreadsheet possui categorias dedicadas para Nike, Jordan, Adidas e outras marcas populares. Todos os links são verificados e atualizados regularmente.',
  articleTitle: 'Guia Completo CSSBuy Spreadsheet',
  articleButton: 'Ler Guia Completo',
  categoryTitle: 'Explorar Categorias de Produtos',
  categoryDropdownLabel: 'Selecione uma categoria:',
  finalCtaTitle: 'Comece agora e descubra os melhores produtos',
  finalCtaSubtitle: 'Acesse o melhor CSSBuy Spreadsheet e encontre produtos verificados com segurança.',
  footerAbout: 'Sobre Nós',
  footerContact: 'Contato',
  footerPrivacy: 'Política de Privacidade',
  footerTerms: 'Termos de Uso',
  footerDisclaimer: 'Disclaimer',
  footerRights: 'Todos os direitos reservados.',
  navHome: 'Início',
  navGuide: 'Guia',
  navShoppingGuide: 'Guia de Compras',
  navCategories: 'Categorias',
  navFAQ: 'FAQ',
  navArticles: 'Artigos',
  productsTitle: 'Produtos em Destaque',
  productsDesc: 'Explore os produtos mais populares do CSSBuy Spreadsheet',
  articleCtaHome: '← Voltar ao Início',
  relatedLinks: 'Links Relacionados',
};

export default common;